import { actionTypes } from '../actions/mercadopago.action';
const initialState = {
    error: {},
    success: false
}

const mercadopagoReducer = (state = initialState, { type, payload }) => {
    switch (type) {

    case actionTypes.SUCCESS:
        return {
            ...state,
            success: payload
        }

    case actionTypes.ERROR:
        return {
            ...state,
            error: payload
        }

    default:
        return state
    }
}

export default mercadopagoReducer